export const NAVIGATE = 'iHR/Routing/NAVIGATE';
export const RESET_SERVER_ERRORS = 'iHR/Routing/RESET_SERVER_ERRORS';
export const LOCATION_CHANGE = 'iHR/Routing/LOCATION_CHANGE';
export const SET_FORCE_404_DATA = 'iHR/Routing/SET_FORCE_404_DATA';
export const SET_SERVER_ERROR = 'iHR/Routing/SET_SERVER_ERROR';
export const SET_PAGE_INFO = 'iHR/Routing/SET_PAGE_INFO';
